<template>
  <div>
    <div class="label__search_container">
      <label class="label_input_search">{{ label }}</label>
      <div>
        <div class="custom-select">
          <div class="selected" :class="{ open: open, notSelectedAfterBlur: showErrorMessage }">
            <span v-if="!optionLabel" class="custom-select-placeholder">{{ placeholder }}</span>
            <span v-else>{{ optionLabel }}</span>
            <RingLoader v-if="isLoading" />
            <svg v-show="!open && !isLoading" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="m5 7.5 5 5 5-5" stroke="#737373" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <svg v-show="open && !isLoading" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="m5 12.5 5-5 5 5" stroke="#737373" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="items" v-show="open">
            <div v-if="isLoading" class="items_empty">Cargando Puntos Sharf...</div>
            <div v-else-if="optionList.length > 0" class="items_list">
              <div
                v-for="(option, i) of optionList"
                :key="i"
                @click="onClickElement(option)"
              >
                <div v-if="isForScharffPoints" class="item_option forScharffPoint">
                  <div class="point-name-row">
                    <span class="point-name">{{ option.Name }}</span>
                    <button
                      type="button"
                      v-if="hasOpeningHours(option)"
                      class='opening_hours_button'
                      @click.stop="openOpeningHours(option)"
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"/><path d="M12 7v5.5l3.5 2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
                      <span>Ver horarios</span>
                    </button>
                  </div>
                  <div class="address_and_schedule">
                    <span class="address">{{ option.Address }}</span>
                    <span class='schedule'>{{`${option.OpenTime.substring(0,5)} - ${option.CloseTime.substring(0, 5)}`}}</span>
                    <div class="point_tags">
                      <PointCapacityTag :point="option" />
                      <PointOfSaleTag :point="option" />
                      <CashOnDeliveryTag :point="option" />
                    </div>
                  </div>
                </div>
                <div v-else class="item_option">
                  {{ option.label }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <ErrorMessage v-if="showErrorMessage" :message="errorMessage"/>
        <OpeningHoursModal
          :visible="!!openingHoursPoint"
          :point="openingHoursPoint"
          @close="openingHoursPoint = null"
        />
      </div>
    </div>
  </div>
</template>

<script>
import OpeningHoursModal from "@/components/Shared/OpeningHoursModal.vue";
import { hasOpeningHours } from "@/utils/openingHours";
import PointCapacityTag from "@/components/Shared/PointCapacityTag.vue";
import PointOfSaleTag from "@/components/Shared/PointOfSaleTag.vue";
import CashOnDeliveryTag from "@/components/Shared/CashOnDeliveryTag.vue";
import ErrorMessage from '../ErrorMessage.vue'
import RingLoader from '../Loaders/RingLoader.vue'

export default {
  components: {
    PointCapacityTag,
    PointOfSaleTag,
    CashOnDeliveryTag,
    ErrorMessage,
    RingLoader,
    OpeningHoursModal,
  },
  props: {
    value: {
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    isForScharffPoints: {
      type: Boolean,
      default: false
    },
    optionList: {
      type: Array,
      required: true
    },
    errorMessage: {
      type: String,
      default: 'Error'
    },
    showEmptyInputError: {
      type: Boolean,
      default: false
    },
    isOptional: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      open: false,
      notSelectedAfterBlur: false,
      isClickedInside: false,
      openingHoursPoint: null
    }
  },
  methods: {
    hasOpeningHours,
    openOpeningHours(point) {
      this.openingHoursPoint = point
    },
    onClickElement(option) {
      setTimeout(() => {
        this.open = false
      }, 50)
      this.notSelectedAfterBlur = false
      this.$emit('input', option?.ScharffPointId || option?.id)
      this.$emit('change', option)
    },
    handleClickOutside(event) {
      if (this.openingHoursPoint) return
      // Para checar si se hizo click dentro o fuera de todo esto
      const clickedComponent = event.target
      const isClickedInside = this.$el.contains(clickedComponent)
      this.isClickedInside = isClickedInside

      if (this.open && !isClickedInside) {
        this.notSelectedAfterBlur = !this.optionLabel
      }

      this.open = isClickedInside
    }
  },
  created () {
    this.$watch('showEmptyInputError', value => {
      if(value) {
        this.notSelectedAfterBlur = true
      }
    })
    document.addEventListener('click', this.handleClickOutside)
  },
  computed: {
    optionLabel() {
      const optionSelected = this.optionList.find(option => {
        const optionvalue = option?.ScharffPointId || option?.id
        return optionvalue === this.value
      })
      return optionSelected?.Name || optionSelected?.label || ''
    },
    showErrorMessage(){
      return this.isOptional  && this.notSelectedAfterBlur
    }
  },
  unmounted() {
    document.removeEventListener('click', this.handleClickOutside);
  },
}
</script>

<style lang="scss" scoped>
.label__search_container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.label_input_search {
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #1A1A1A !important;
  text-align: left;
}
.custom-select {
  position: relative;
  width: 100%;
  text-align: left;
}
.custom-select .selected {
  padding: 0 16px;
  cursor: pointer;
  user-select: none;
  min-height: 50px;
  border: 1px solid #737373;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.custom-select .selected:hover {
  border: 1px solid #1A1A1A;
}
.custom-select .selected.open { border: 2px solid #1A1A1A }
.custom-select .selected.notSelectedAfterBlur { border: 1px solid #E50000 }
.custom-select-placeholder {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #737373;
}
.custom-select .items {
  border-radius: 6px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  position: absolute;
  background-color: #fff;
  left: 0;
  right: 0;
  z-index: 99;
  max-height: 250px;
  overflow: overlay; /* para el scroll sea sobre las coasas */
  margin-top: 5px;
}
.items_empty {
  padding: 0 16px;
  color: #737373;
}

.opening_hours_button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border: 1px solid #D0D0D0;
  border-radius: 999px;
  background: transparent;
  font-size: 12px;
  line-height: 18px;
  color: #1A1A1A;
  white-space: nowrap;
  cursor: pointer;
}

.opening_hours_button:hover { background: rgba(0, 0, 0, 0.05) }

.point-name-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.item_option {
  cursor: pointer;
  user-select: none;
  font-style: normal;
  color: #1A1A1A;
  padding: 12px 16px;
  &.forScharffPoint{
    line-height: 47px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 12px 1em;
  }

  .point-name {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
  }
  .address_and_schedule {
    display: flex;
    flex-direction: column;

    .address {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
    }
    .schedule {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #737373;
    }
    .capacity {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #B20000;
    }
    .point_tags {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 6px;
      line-height: 1;
    }
  }
}
.custom-select .items .items_list > div:not(:last-child) {
  border-bottom: 1px solid #DEDEDE;
}
.item_option:hover { background: rgba(0, 0, 0, 0.05) }
.item_option:active { background: rgba(0, 0, 0, 0.15) }

.custom-select .items::-webkit-scrollbar {
  width: 15px;
}
.custom-select .items::-webkit-scrollbar-thumb {
  background: rgba(26, 26, 26, 0.5);
  background-clip: content-box;
  border: 5px solid transparent;
  border-radius: 15px;
}
</style>
